import { createApp } from "vue";
import {  createWebHashHistory, createRouter } from "vue-router";
import store from "./store/store";
import App from "./App.vue";
import MainPage from "@/components/MainPage.vue";
import LoginPage from "@/components/LoginPage.vue";
import StudentPage from "@/components/Student/StudentPage.vue";
import AddStudent from "@/components/Student/AddStudent.vue";
import TeacherPage from "@/components/Teacher/TeacherPage.vue";
import AddTeacher from "@/components/Teacher/AddTeacher.vue";
import ClsPage from "@/components/ClsPage.vue";
import "font-awesome/scss/font-awesome.scss";
import DashBoard from "@/components/DashBoard.vue";
import SubjectPage from "./components/SubjectPage.vue";
import StaffPage from "./components/StaffPage.vue";
import AppointmentPage from "./components/AppointmentPage.vue";
import BatchPage from "./components/BatchPage.vue";
import ExamSetupPage from "./components/Exam/ExamSetupPage.vue";
import ExamTypePage from "./components/Exam/ExamTypePage.vue";
import EnquiryPage from "./components/EnquiryPage.vue";
import ComplaintPage from "./components/ComplaintPage.vue";
import TransportPage from "./components/TransportPage.vue";
import AnnouncementPage from "./components/AnnouncementPage.vue";
import ApplyLeavePage from "./components/ApplyLeavePage.vue";
import BirthdayPage from "./components/BirthdayPage.vue";
import HomeWorkPage from "./components/HomeWorkPage.vue";
import PromotePage from "./components/PromotePage.vue";
import ProfilePage from "./components/ProfilePage.vue";
import FestivalPage from "./components/FestivalPage.vue";
import HolidayPage from "./components/HolidayPage.vue";
import Feespage from "./components/Fee/FeesPage.vue";
import GradePage from "./components/Exam/GradePage.vue";
import SSCPassPage from "./components/SSCPassPage.vue";
import CollectPage from "./components/Fee/CollectPage.vue";
import AttendancePage from "./components/AttendancePage.vue";
import GeneralSettingPage from "./components/GeneralSettingPage.vue";
import FeesgroupPage from "./components/Fee/feesgroupPage.vue";
import ClassTimetablePage from "./components/ClassTimetablePage.vue";
import ExportPage from "./components/ExportPage.vue";
import IdcardPage from "./components/IdcardPage.vue";
import ExamTimetablePage from "./components/Exam/ExamTimetablePage.vue";
import MarksPage from "./components/Exam/MarksPage.vue";
import CategoryPage from "./components/CategoryPage.vue";
import RemindersPage from "./components/RemindersPage.vue";
import BookListPage from "./components/BookListPage.vue";
import ParentListPage from "./components/ParentListPage.vue";
import TeacherIdPage from "./components/Teacher/TeacherIdPage.vue";
import StaffIdPage from "./components/StaffIdPage.vue";
import PaymentDetails from "./components/Fee/PaymentDetails.vue";
import NewsPage from "./components/NewsPage.vue";
import HelpPage from "./components/HelpPage.vue";
import UserListPage from "./components/UserListPage.vue";
import AttndReportPage from "./components/AttndReportPage.vue";
import HallticketPage from "./components/HallticketPage.vue";
import ContactListPage from "./components/ContactListPage.vue";
import AccessPage from "./components/AccessPage.vue";
import InfoPage from "./components/InfoPage.vue";
import DocumentsPage from "./components/DocumentsPage.vue";
import AwardsPage from "./components/AwardsPage.vue";
import StudentReportPage from "./components/StudentReportPage.vue";
import NotificationsPage from "./components/NotificationsPage.vue";
import BannersPage from "./components/BannersPage.vue";
import IdCardList from "./components/IdCardList.vue";
import BulkFiles from "./components/BulkFiles.vue";
/* import "bootstrap/dist/css/bootstrap.css";
import "bootstrap"; */
const routes = [
  {
    path: "/",
    component: MainPage,
    children: [
      {
        path:"/banners",
        component: BannersPage
      },
       {
        path:"/notifications",
        component: NotificationsPage
      },
      {
        path:"/studentreport",
        component: StudentReportPage
      },
      {
        path:"/awards",
        component: AwardsPage
      },
      {
        path:"/info",
        component: InfoPage
      },
      {
        path:"/access",
        component: AccessPage
      },
      {
        path:"/contactlist",
        component: ContactListPage
      },
      {
        path:"/hallticket",
        component: HallticketPage
      },
      {
        path:"/attndreport",
        component: AttndReportPage
      },
      {
        path:"/userlist",
        component: UserListPage
      },
      {
        path:"/help",
        component: HelpPage
      },
      {
        path:"/news",
        component: NewsPage
      },
      {
        path:"/Payment",
        component: PaymentDetails
      },
      {
        path:"/staffidcard",
        component: StaffIdPage
      },
      {
        path:"/teacheridcard",
        component: TeacherIdPage
      },
       {
        path:"/parent",
        component: ParentListPage
      },
       {
        path:"/booklist",
        component: BookListPage
      },
      {
        path:"/reminders",
        component: RemindersPage
      },
      {
        path:"/category",
        component: CategoryPage
      },
      {
        path:"/marks",
        component: MarksPage
      },
      {
        path:"/examtimetable",
        component: ExamTimetablePage
      },
      {
        path:"/idcard",
        component: IdcardPage
      },
      {
        path:"/export",
        component: ExportPage
      },
      {
        path:"/classtimetable",
        component: ClassTimetablePage
      },
      {
        path:"/attendance",
        component: AttendancePage
      },
      {
        path:"/collect",
        component: CollectPage
      },
      {
        path:"/feesgroup",
        component: FeesgroupPage
      },
      {
        path:"/sscpass",
        component: SSCPassPage
      },
      {
        path:"/grade",
        component: GradePage
      },
      {
        path:"/fee",
        component:Feespage
      },
      {
        path:"/holiday",
        component: HolidayPage
      },
      {
        path:"/festival",
        component: FestivalPage
      },
      {
        path:"/profile",
        component: ProfilePage
      },
      {
        path:"/generalsetting",
        component: GeneralSettingPage
      },
      {
        path:"/promote",
        component: PromotePage
      },
      {
        path:"/homework",
        component: HomeWorkPage
      },
      {
        path:"/birthday",
        component: BirthdayPage
      },
      {
        path:"/applyleave",
        component: ApplyLeavePage
      },
      {
        path:"/announcement",
        component: AnnouncementPage
      },
      {
        path:"/transport",
        component: TransportPage
      },
      {
        path:"/complaint",
        component: ComplaintPage
      },
      {
        path:"/enquiry",
        component: EnquiryPage
      },
      {
        path:"/examsetup",
        component: ExamSetupPage
      },
      {
        path:"/examtype",
        component: ExamTypePage
      },
      {
        path:"/batch",
        component: BatchPage
      },
      {
        path:"/appointment",
        component: AppointmentPage
      },
      {
        path:"/staff",
        component: StaffPage
      },
      {
      path:"/subject",
      component: SubjectPage
      },
      {
        path: "/dashboard",
        component: DashBoard,
      },
      {
        path: "/students",
        component: StudentPage,
      },
      {
        path: "/students/add",
        component: AddStudent,
      },
      {
        path: "/teachers",
        component: TeacherPage,
      },
      {
        path: "/teachers/add",
        component: AddTeacher,
      },
      {
        path: "/cls",
        component: ClsPage,
      },
      {
        path: "/idcardlist",
        component: IdCardList,
      },
      {
        path: "/bulkfiles",
        component:BulkFiles,
      },
    ],
  },
  { path: "/login", component: LoginPage },
  { path: "/documents", component: DocumentsPage },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
    return;
  }
 if (to.path === '/documents') {
    next();
    return;
  }
  const token = store.state.token || localStorage.getItem('token');
  
  if (!token) {
    next('/login');
  } else {
    next();
  }
});


const app = createApp(App);
app.use(store);
app.use(router);
app.mount("#app");

//createApp(App).use(router).mount('#app')
